// Career Transition Blueprint — question catalogue.
export const CAREER_QUESTIONS = [
    // Q1-Q5 misalignment
    { id: 1, category: "misalignment", text: "How fulfilled do you currently feel in your work or career?", options: [
        { text: "Very fulfilled — my work feels meaningful and satisfying.", score: 1 },
        { text: "Mostly fulfilled, although there are things I would change.", score: 2 },
        { text: "Some parts fulfil me, but something important feels missing.", score: 3 },
        { text: "Mostly unfulfilled — my work no longer feels right for me.", score: 4 },
        { text: "Deeply unfulfilled — I strongly feel that I don't want to continue on this path.", score: 5 },
    ]},
    { id: 2, category: "misalignment", text: "How well does your current career reflect who you are today — your interests, values and priorities?", options: [
        { text: "Very well.", score: 1 }, { text: "Mostly well.", score: 2 },
        { text: "Somewhat, but I feel I may be outgrowing it.", score: 3 },
        { text: "Very little — there is a significant mismatch.", score: 4 },
        { text: "Not at all — I feel disconnected from the person I have to be in this career.", score: 5 },
    ]},
    { id: 3, category: "misalignment", text: "How motivated do you generally feel about your current work?", options: [
        { text: "Highly motivated.", score: 1 }, { text: "Mostly motivated.", score: 2 },
        { text: "Motivation comes and goes.", score: 3 },
        { text: "I frequently struggle to feel motivated.", score: 4 },
        { text: "I feel deeply disengaged and mostly continue because I feel I have to.", score: 5 },
    ]},
    { id: 4, category: "misalignment", text: "How often do you find yourself thinking, \u201cI should be doing something else with my career\u201d?", options: [
        { text: "Rarely.", score: 1 }, { text: "Occasionally.", score: 2 },
        { text: "Sometimes.", score: 3 }, { text: "Frequently.", score: 4 },
        { text: "Constantly.", score: 5 },
    ]},
    { id: 5, category: "misalignment", text: "If nothing changed in your career for the next three years, how would you feel?", options: [
        { text: "Content.", score: 1 }, { text: "Mostly okay.", score: 2 },
        { text: "Disappointed.", score: 3 }, { text: "Very unhappy.", score: 4 },
        { text: "The thought of remaining here feels extremely difficult.", score: 5 },
    ]},
    // Q6-Q10 distress
    { id: 6, category: "distress", text: "How much stress or emotional strain does your current career situation cause you?", options: [
        { text: "Very little.", score: 1 }, { text: "Occasionally.", score: 2 },
        { text: "Moderately.", score: 3 }, { text: "Significantly.", score: 4 },
        { text: "It occupies a major part of my emotional life.", score: 5 },
    ]},
    { id: 7, category: "distress", text: "How much time do you spend worrying, overthinking or analysing your career?", options: [
        { text: "Very little.", score: 1 }, { text: "Occasionally.", score: 2 },
        { text: "Frequently.", score: 3 }, { text: "Most days.", score: 4 },
        { text: "I find it extremely difficult to stop thinking about it.", score: 5 },
    ]},
    { id: 8, category: "distress", text: "How much is your career situation affecting other areas of your life, such as confidence, relationships, sleep, energy or enjoyment?", options: [
        { text: "Hardly at all.", score: 1 }, { text: "Slightly.", score: 2 },
        { text: "Moderately.", score: 3 }, { text: "Significantly.", score: 4 },
        { text: "Multiple areas of my life are being affected.", score: 5 },
    ]},
    { id: 9, category: "distress", text: "How emotionally drained do you currently feel because of your work or career situation?", options: [
        { text: "Not drained.", score: 1 }, { text: "Occasionally drained.", score: 2 },
        { text: "Moderately drained.", score: 3 }, { text: "Frequently drained.", score: 4 },
        { text: "Deeply exhausted by it.", score: 5 },
    ]},
    { id: 10, category: "distress", text: "How much does your current career situation affect the way you feel about yourself?", options: [
        { text: "Hardly at all.", score: 1 }, { text: "Slightly.", score: 2 },
        { text: "Moderately.", score: 3 }, { text: "Significantly.", score: 4 },
        { text: "My career situation strongly affects my confidence or sense of self-worth.", score: 5 },
    ]},
    // Q11-Q15 stuckness
    { id: 11, category: "stuckness", text: "How clear are you about what you would rather do next?", options: [
        { text: "I'm happy with my current direction and don't currently need an alternative.", score: 1 },
        { text: "I know I want something different, but I have almost no idea what.", score: 2 },
        { text: "I have several possibilities but struggle to choose.", score: 3 },
        { text: "I have a reasonably clear idea of the direction I want.", score: 4 },
        { text: "I know what I want to explore next, but I'm struggling to move toward it.", score: 5 },
    ]},
    { id: 12, category: "stuckness", text: "How difficult is it for you to make decisions about your career transition?", options: [
        { text: "Not difficult.", score: 1 }, { text: "Slightly difficult.", score: 2 },
        { text: "I frequently go back and forth.", score: 3 },
        { text: "Very difficult.", score: 4 },
        { text: "I feel trapped in analysis and struggle to make a decision.", score: 5 },
    ]},
    { id: 13, category: "stuckness", text: "How much do fear and uncertainty stop you from taking career-related action?", options: [
        { text: "Very little.", score: 1 }, { text: "Occasionally.", score: 2 },
        { text: "Sometimes.", score: 3 }, { text: "Frequently.", score: 4 },
        { text: "Fear or uncertainty repeatedly prevents me from moving forward.", score: 5 },
    ]},
    { id: 14, category: "stuckness", text: "How much do practical concerns — money, responsibilities, age, qualifications, job security or family expectations — make you feel unable to change?", options: [
        { text: "Very little.", score: 1 }, { text: "Slightly.", score: 2 },
        { text: "Moderately.", score: 3 }, { text: "Significantly.", score: 4 },
        { text: "They currently make change feel almost impossible.", score: 5 },
    ]},
    { id: 15, category: "stuckness", text: "How often do you research, plan, take courses or think about changing careers without taking meaningful next steps?", options: [
        { text: "Rarely.", score: 1 }, { text: "Occasionally.", score: 2 },
        { text: "Sometimes.", score: 3 }, { text: "Frequently.", score: 4 },
        { text: "Constantly — I keep preparing or researching but still don't move.", score: 5 },
    ]},
    // Q16-Q18 readiness
    { id: 16, category: "readiness", text: "How strongly do you want something about your career situation to change?", options: [
        { text: "I don't currently feel much needs to change.", score: 1 },
        { text: "A few things could improve.", score: 2 },
        { text: "I definitely want some change.", score: 3 },
        { text: "I strongly want change.", score: 4 },
        { text: "I no longer want to continue with things exactly as they are.", score: 5 },
    ]},
    { id: 17, category: "readiness", text: "How willing are you to explore realistic alternatives, even if you don't yet know exactly what your next career should be?", options: [
        { text: "Not currently interested.", score: 1 },
        { text: "Curious but not ready.", score: 2 },
        { text: "Somewhat willing.", score: 3 },
        { text: "Very willing.", score: 4 },
        { text: "I'm actively ready to explore alternatives.", score: 5 },
    ]},
    { id: 18, category: "readiness", text: "Which statement best describes you right now?", options: [
        { text: "I'm reasonably satisfied with my current career.", score: 1 },
        { text: "Something feels off, but I'm not seriously considering change yet.", score: 2 },
        { text: "I'm seriously thinking about change but don't know what direction to take.", score: 3 },
        { text: "I know I want change, but something is stopping me from moving.", score: 4 },
        { text: "I'm ready to start taking concrete steps toward my next direction.", score: 5 },
    ]},
    // Q19-Q20 personalisation
    { id: 19, category: "personal", multi: true, text: "What are the biggest challenges you're facing with your career right now?", subtext: "Select all that apply.", options: [
        "I don't know what career would suit me.",
        "I know what I want, but I'm afraid to pursue it.",
        "Financial security prevents me from changing.",
        "I worry I'm too old or it's too late to start again.",
        "I don't feel qualified enough.",
        "I have too many interests and can't choose.",
        "I've lost confidence in myself.",
        "I'm exhausted and don't know whether I need a new career or simply a break.",
        "My current career doesn't feel meaningful anymore.",
        "Family or social expectations influence my decisions.",
        "I'm afraid I'll make the wrong decision.",
        "I've been preparing for change but keep postponing action.",
        "Something else.",
    ]},
    { id: 20, category: "personal", multi: false, text: "What kind of support are you looking for right now?", options: [
        "I'm mainly exploring.",
        "I want greater clarity about what I want.",
        "I want tools or resources I can use myself.",
        "I'm considering professional support.",
        "I'm actively looking for support with my career transition.",
    ]},
];
